import {Base, model, endpoint, belongsTo, hasMany, getFrom} from '@scoutgg/ftw/source/lib/model'
import serialize from '@scoutgg/ftw/source/decorators/serialize'
import rules from '@scoutgg/scoring-rules'
import sports from '@scoutgg/scoring-rules/sports'

@model('Season')
@endpoint('seasons', {root: '/api'})
@belongsTo('league')
@belongsTo('tablePositions', { foreign: 'tablePositionIds' })
@hasMany('matches')
@hasMany('teams')
@hasMany('seasonSources')
@getFrom('league', ['isDuel', 'isRacing', 'sport', 'isCrossCountry', 'isTimeTrial'])
@serialize([
  'tablePositions',
])
export class Season extends Base {
  get name() {
    return [(this.league && this.league.name) || '', this.season].join(' ')
  }

  get iconUrl() {
    if(!this.icon) {
      return 'https://statcenter.scoutgg.net/s3/uploads/assets/league_placeholder.svg'
    }
    return `https://statcenter.scoutgg.net/s3/uploads/assets/${this.icon}`
  }
  get rules() {
    return rules(this.sport, this.ruleVersion)
  }
  get positions() {
    const allPositions = Object.values(sports[this.sport])
      .flatMap(version => version.positions)
      .reduce((set, pos) => set.add(pos), new Set())

    return Array.from(allPositions)
  }
}
